export default (state = [], action) => {
  switch (action.type) {
    case "UPDATE_MEDICINAL_MARIJUANA":
      return action.payload.medicinalMarijuana;
    default:
      return state;
  }
}
